"use client";

import { useEffect } from "react";
import { flushPendingLandingCtaClicks } from "@/services/analytics";

/** Delivers landing CTA clicks that survived a navigation in browser storage. */
export default function LandingCtaClickQueueFlusher() {
  useEffect(() => {
    void flushPendingLandingCtaClicks();
  }, []);

  return null;
}
